import { FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";
import { ChatSupport, ChatSupportDoc } from "../../entities/chat-support.entity";
import { FireDoc } from "../../types/util.types";

export const chatSupportConverter: FirestoreDataConverter<ChatSupportDoc> = {
  toFirestore(chat: ChatSupport): ChatSupportDoc {
    return {
      createdAt: chat.createdAt,
      updatedAt: chat.updatedAt,
      status: chat.status,
      unreadCountSupport: chat.unreadCountSupport,
      unreadCountUser: chat.unreadCountUser,
    };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot<ChatSupportDoc>,
    options: SnapshotOptions
  ): FireDoc<ChatSupportDoc>["DocWithIdAndRef"] {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      docRef: snapshot.ref,
      ...data,
    };
  },
};
